import main from "@/main";
import moment from "moment";

export default {
    requiredcombo: value => {
        if (value === undefined || value === null)
            return main.i18n().t("common.required");

        return true;
    },

    email: value => {
        if (value === undefined || value === null)
            return true;

        if (value.length === 0) {
            return true;
        }

        // ... sorry fot that ..
        if (value.endsWith(".bnpparibas")) {
            return true;
        }

        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Keine gültige Email Adresse.";
    },

    future: value => {
        if (value === undefined || value === null)
            return true;

        //   const date = null;

        return false;
    },

    required (value)  {
        if ((!value || value.length === 0)) {
            return main.i18n().t("rules.required");
        }

        return true;
    },

    requiredInCombo (value) {
        if (value === undefined || value === null || !value.id)
            return main.i18n().t("common.required");

        return true;
    },

    requiredOnTermination (value, status)  {
        if ((!value || value.length === 0) && status.type === 'T') {
            return main.i18n().t("rules.required");
        }

        return true;
    },

    requiredOnStatus (value, status, required)  {
        if ((!value || value.length === 0) && status.id === required) {
            return main.i18n().t("rules.required");
        }

        return true;
    },

    processingIntervall (dateStart, dateEnd) {
        if (moment(dateEnd).isBefore(dateStart)) {
            return false;
        }
    }
}